module.exports = __webpack_public_path__ + "ccb7bf45a8765dc91df26997365239aa.svg";